import { default as UIDefault } from './default/';

export const UIs = UIDefault;


/** WEBPACK FOOTER **
 ** ./src/UIs/index.js
 **/